import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {SitePublicService} from 'src/app/services/site-public.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-carousel-dialog',
  templateUrl: './carousel-dialog.component.html',
  styleUrls: [ './carousel-dialog.component.scss' ]
})

export class CarouselDialogComponent implements OnInit, OnDestroy {

  public matcher = new FormErrorStateMatcher(); // 
  public entityForm: FormGroup;
  public isEdit: boolean = false;

  // Variáveis para upload
  selectedFileBig: File | null = null;
  selectedFileNameBig: any | null = null;
  storedImageBig: any | null = null;

  selectedFileSmall: File | null = null;
  selectedFileNameSmall: any | null = null;
  storedImageSmall: any | null = null;

  public locations = [];

  constructor (
    public _sitePublicService: SitePublicService,
    public matDialogRef: MatDialogRef<CarouselDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log("dialog data: " + JSON.stringify(this.data));
    this.entityForm = this.createForm(this.data)
    this.isEdit = this.data.id !== '0';

    this.locations = this._sitePublicService.loadLocations();
    //console.log(this.isEdit)
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
  }

  ngOnDestroy () { }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      srcSmall: new FormControl(data.srcSmall),
      fileSmall: new FormControl(data.fileSmall, [ Validators.required ]),
      srcBig: new FormControl(data.srcBig),
      fileBig: new FormControl(data.fileBig, [ Validators.required ]),
      link: new FormControl(data.link),
      key: new FormControl(data.key),
      location: new FormControl(data.location, [ Validators.required ]),
      position: new FormControl(data.position, [ Validators.required ]),
      dateIn: new FormControl(data.dateIn?.toDate() || null, [ Validators.required ]),
      dateOut: new FormControl(data.dateOut?.toDate() || null, [ Validators.required ]),
    });

    this.selectedFileNameBig = data.fileBig;
    this.storedImageBig = data.srcBig;

    this.selectedFileNameSmall = data.fileSmall;
    this.storedImageSmall = data.srcSmall;

    return form
  }

  onFileSelectedBig (event: any): void {
    const file: File = event.target.files[ 0 ];
    if (file) {
      this.selectedFileBig = file;
      this.entityForm.controls.fileBig.setValue(file.name);
      this.selectedFileNameBig = file.name;
      var reader = new FileReader();
      reader.readAsDataURL(this.selectedFileBig);
      reader.onload = (_event) => {
        this.storedImageBig = reader.result;
      }

    }
  }

  onFileSelectedSmall (event: any): void {
    const file: File = event.target.files[ 0 ];
    if (file) {
      this.selectedFileSmall = file;
      this.entityForm.controls.fileSmall.setValue(file.name);
      this.selectedFileNameSmall = file.name;
      var reader = new FileReader();
      reader.readAsDataURL(this.selectedFileSmall);
      reader.onload = (_event) => {
        this.storedImageSmall = reader.result;
      }

    }
  }

}

